/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { axios } from '~/util/http/axioshttp';
import { queryOptions } from '@tanstack/react-query';
import type { ReferralNotificationPreviewViewModel } from './ReferralNotificationPreviewViewModel'; 

export function getReferralNotificationPreviewOptions(zipCode: string, disciplines: string, onSuccess?: (result: ReferralNotificationPreviewViewModel) => void) {
	return queryOptions({
		queryKey: ['referral-notification-preview', zipCode, disciplines],
		queryFn: async () => {
			const url = '/_api/v1/homehealth/legacy/referrals/queries/getreferralnotificationpreview/' + '?zipCode=' + zipCode + '&disciplines=' + disciplines;
			const resp = await axios.get<ReferralNotificationPreviewViewModel>(url);
			if(onSuccess) {
				onSuccess(resp.data);
			}
			return resp.data;
		},
        enabled: Boolean(zipCode) && Boolean(disciplines)
	});
}